import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

interface MenuItemProps {
  icon: any;
  title: string;
  link: string;
  isNew?: boolean;
  target?: string;
  collapsed?: boolean;
  active?: boolean;
  onClick?: () => void;
}

export default function MenuItem({
  icon: Icon,
  title,
  link,
  isNew,
  target,
  collapsed,
  active,
}: MenuItemProps) {
  const location = useLocation();
  const [showLabel, setShowLabel] = useState(true);

  const isActive =
    link === '/'
      ? location.pathname === '/' ||
        location.pathname === '/insights' ||
        location.pathname.startsWith('/insights/')
      : location.pathname.startsWith(link);

  useEffect(() => {
    if (isActive) {
      setTimeout(() => {
        localStorage.setItem('hasSeenPage', 'true');
        setShowLabel(false);
      }, 7000);
    }
  }, [isActive]);

  return (
    <AnimatePresence initial={false}>
      <NavLink
        to={link}
        target={target}
        className={`px-3 py-2 flex items-center gap-2 rounded-sm relative hover:bg-navigation-tab-hover overflow-hidden ${
          active
            ? 'bg-navigation-tab-active  text-text-primary-heading border-primary'
            : 'text-text-primary-body'
        }`}
      >
        {active && (
          <div className="w-[2px] bg-primary absolute left-0 top-0 h-full" />
        )}
        <div className="w-[50px] py-2 flex items-center justify-center">
          <Icon active={active} />
        </div>

        <motion.p
          initial={false}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -10 }}
          transition={{
            duration: 0.25,
            ease: 'easeInOut',
            delay: 0.15,
          }}
          className={`overflow-hidden whitespace-nowrap ${collapsed ? 'hidden' : 'block'} ${active ? 'font-bold' : ''}`}
        >
          {title}
        </motion.p>

        {isNew && (
          <motion.label
            layout
            className={`text-uppercase text-white-1 bg-[#884624] rounded-sm mb-2 transition-all duration-500 ease-in-out ${
              collapsed
                ? 'absolute left-[35px] top-[9px] py-[1px] px-[2px] text-[7px] font-semibold'
                : 'relative py-[2px] px-[4px] font-bold text-[8px] ml-[-2px] mt-[4px]'
            }`}
          >
            BETA
          </motion.label>
        )}
      </NavLink>
    </AnimatePresence>
  );
}
